import { useQuery } from '@tanstack/react-query'
import { type BookingRevocationEligibilityDto } from '../../../qourses-api-client'
import { qoursesApi } from '../../api/qourses.tsx'

export default function useGetCustomerBookingRevocationEligibility(bookingId: string): {
  bookingRevocationEligibility: BookingRevocationEligibilityDto
  isLoading: boolean
  isError: boolean
  refetch: () => void
  isRefetching: boolean
} {
  const {
    data: bookingRevocationEligibility,
    isLoading,
    isError,
    refetch,
    isRefetching,
  } = useQuery(['booking', 'customer', bookingId, 'revocationEligibility'], async () => {
    return qoursesApi.paymentCustomer.paymentCustomerControllerGetBookingRevocationEligibilityV1(
      bookingId,
    )
  })

  return { bookingRevocationEligibility, isLoading, isError, refetch, isRefetching }
}
